package presentation.screens.videoPlayer

import androidx.lifecycle.SavedStateHandle
import androidx.lifecycle.ViewModel
import androidx.navigation.toRoute
import data.VideoRepository
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.update
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import com.kinoshazam.model.Route

interface VideoPlayerComponentT {

    fun onAction(action: VideoPlayerMVIAction)

    data class VideoPlayerState(
        val videoUrl: String,
        val isLoading: Boolean = false,
        val isError: Boolean = false,
    )
}

class VideoPlayerViewModel(
    private val savedStateHandle: SavedStateHandle,
) : ViewModel(), KoinComponent {

    private val repository: VideoRepository by inject()

    private val videoUrl = savedStateHandle.toRoute<Route.VideoPlayer>().url

    private val _state = MutableStateFlow(VideoPlayerComponentT.VideoPlayerState(videoUrl))
    val state: StateFlow<VideoPlayerComponentT.VideoPlayerState> = _state

    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, error ->
        _state.update { it.copy(isLoading = false, isError = true) }
    }

    private var job: Job? = null

    fun onAction(action: VideoPlayerMVIAction) {
        when (action) {
            is VideoPlayerMVIAction.OnBackClicked -> {}
        }
    }
}
